/*eslint-disable*/
import { defineMessage } from '@lingui/macro';

export function getAuditText(code) {
  return AUDIT_MESSAGE[code] || code;
}

export const AUDIT_MESSAGE = {
 
 "AC_DatasetUpdateItem": defineMessage`Item updated`, 
 "AC_DatasetCreateItem": defineMessage`Item created`, 
 "AC_DatasetDeleteItem": defineMessage`Item deleted`, 
 "AC_DatasetCreateItemsFromAttachment": defineMessage`Records created using IDP connector`, 
 "AC_DatasetBatchUpdate": defineMessage`Items updated in batch`, 
 "AC_DatasetImport": defineMessage`Bulk import completed`, 
 "AC_DatasetExport": defineMessage`Bulk export completed`, 
 "AC_DatasetViewCreate": defineMessage`Dataset view created`, 
 "AC_DatasetViewModify": defineMessage`Dataset view modified`, 
 "AC_DatasetViewUpdateItem": defineMessage`Item updated`, 
 "AC_DatasetViewCreateItem": defineMessage`Item created`, 
 "AC_DatasetFileDownload": defineMessage`File download`, 
 "AC_DatasetViewFileDownload": defineMessage`File download`, 
 "AC_DatasetViewBatchUpdate": defineMessage`Items updated in batch`, 
 "AC_DatasetViewExport": defineMessage`Bulk export completed`, 
 "AC_DatasetItemCreation": defineMessage`Item created`, 
 "AC_DatasetItemActions": defineMessage`Item acted upon`, 
 "AC_DatasetBulkActions": defineMessage`Items acted upon in bulk`, 
 "AC_DatasetBatchActions": defineMessage`Items acted upon in batch`, 
 "AC_DatasetExportActions": defineMessage`Dataset export actions`, 
 "AC_DatasetViewCreation": defineMessage`Dataset view created`, 
 "AC_DatasetViewModification": defineMessage`Dataset view modified`, 
 "AC_DatasetViewItemCreation": defineMessage`Item created`, 
 "AC_DatasetViewItemUpdate": defineMessage`Item acted upon`, 
 "AC_DatasetViewBatchActions": defineMessage`Items acted upon in batch`, 
 "AC_DatasetViewBulkActions": defineMessage`Items acted upon in bulk`, 
 "AC_FileDownload": defineMessage`Download actions`, 
 "AC_DataExport": defineMessage`Export actions`, 
 "AuditCode_ProcessCommentAdd": defineMessage`Comment added`, 
 "AuditCode_ProcessCommentModify": defineMessage`Comment modified`, 
 "AuditCode_ProcessCommentDelete": defineMessage`Comment deleted`, 
 "AuditCode_ProcessCreateReply": defineMessage`Reply added for comment`, 
 "AuditCode_ProcessUpdateReply": defineMessage`Reply modified for comment`, 
 "AuditCode_ProcessDeleteReply": defineMessage`Reply deleted for comment`, 
 "AuditCode_ProcessCreateItem": defineMessage`Item created`, 
 "AuditCode_ProcessUpdateItem": defineMessage`Item updated`, 
 "AuditCode_ProcessCopyItem": defineMessage`Item duplicated`, 
 "AuditCode_ProcessSubmitItem": defineMessage`Item submitted`, 
 "AuditCode_ProcessEmailSubmitItem": defineMessage`Item submitted through email`, 
 "AuditCode_ProcessSubmitItemCreate": defineMessage`Item submitted`, 
 "AuditCode_ProcessWithdrawItem": defineMessage`Item withdrawn`, 
 "AuditCode_ProcessRejectItem": defineMessage`Item rejected`, 
 "AuditCode_ProcessEmailRejectItem": defineMessage`Item rejected through email`, 
 "AuditCode_ProcessApproverReassign": defineMessage`Item reassigned by an approver`, 
 "AuditCode_ProcessInitiatorReassign": defineMessage`Item reassigned by initiator`, 
 "AuditCode_ProcessSendBackItem": defineMessage`Item sent back`, 
 "AuditCode_ProcessSelfPickItem": defineMessage`Item picked by assignee`, 
 "AuditCode_ProcessBatchCreateSubmit": defineMessage`Item submitted through an integration`, 
 "AuditCode_ProcessBulkSubmit": defineMessage`Items submitted in bulk`, 
 "AuditCode_ProcessBulkReject": defineMessage`Items rejected in bulk`, 
 "AuditCode_ProcessBulkReassign": defineMessage`Items reassigned in bulk`, 
 "AuditCode_ProcessGeneratePDF": defineMessage`PDF generated`, 
 "AuditCode_ProcessPreviewPDF": defineMessage`PDF previewed`, 
 "AuditCode_Admin_ProcessUpdateItem": defineMessage`Item updated by admin`, 
 "AuditCode_Admin_ProcessBatchUpdate": defineMessage`Item updated by admin`, 
 "AuditCode_Admin_ProcessReassignItem": defineMessage`Item reassigned by admin`, 
 "AuditCode_Admin_ProcessBulkReassign": defineMessage`Item reassigned by admin in bulk`, 
 "AuditCode_Admin_ProcessBatchCompleteItem": defineMessage`Item completed by admin in bulk`, 
 "AuditCode_ProcessPreviewCreateItem": defineMessage`Workflow simulated`, 
 "AuditCode_ProcessPreviewResetProgress": defineMessage`Workflow simulation reset`, 
 "AuditCode_PublicFormCreateItem": defineMessage`Public form created`, 
 "AuditCode_PublicFormUpdateItem": defineMessage`Public form updated`, 
 "AuditCode_PublicFormSubmitItem": defineMessage`Public form submitted`, 
 "AC_ProcessDownloadAttachedFile": defineMessage`Download attached File from item`, 
 "AC_ProcessTableDownloadAttachedFile": defineMessage`Download attached file from table`, 
 "AC_ProcessTableDownloadAttachedImage": defineMessage`Download attached image from table`, 
 "AC_ProcessTableDownloadSignature": defineMessage`Download signature from table`, 
 "AC_ProcessDownloadSignature": defineMessage`Download signature from Item`, 
 "AC_ProcessFormPrint": defineMessage`Form print`, 
 "AC_ProcessFileDownload": defineMessage`File download`, 
 "AC_ProcessExportWorkflowToPdf": defineMessage`Exported workflow as PDF`, 
 "AC_ProcessExportWorkflowToPng": defineMessage`Exported workflow as PNG`, 
 "AC_ProcessItemCreateSubmitFromAttachment": defineMessage`Item created using IDP connector`, 
 "AuditCode_ProcessCollaboration": defineMessage`Process Collaboration`, 
 "AuditCode_ProcessItemActions": defineMessage`Process Item actions`, 
 "AuditCode_ProcessDocumentTemplates": defineMessage`Process document templates`, 
 "AuditCode_ProcessAdminActions": defineMessage`Process Admin actions`, 
 "AuditCode_ProcessAdministration": defineMessage`Process administration`, 
 "AuditCode_ProcessPublicForm": defineMessage`Public form`, 
 "AC_FileDownload": defineMessage`Download actions`, 
 "AC_FormPrint": defineMessage`Print actions`, 
 "AC_ProcessExport": defineMessage`Process export`, 
 "AC_ProcessSubflowDryrun": defineMessage`Process subflow dryrun`, 
 "AC_ProcessSubflowTransactionComplete": defineMessage`Process subflow transaction complete`, 
 "AC_ProcessSubflowChildTransactionUpdate": defineMessage`Process subflow child transaction update`, 
 "AC_ProcessSubflowTriggerParentAction": defineMessage`Process subflow trigger parent action`, 
 "AC_Admin_ProcessCommentCreate": defineMessage`Admin commented on an item`, 
 "AC_Admin_ProcessReplyCreate": defineMessage`Admin replied to a comment`, 
 "AC_Admin_ProcessCommentReaction": defineMessage`Admin reacted to a comment`, 
 "AC_Admin_ProcessReplyReaction": defineMessage`Admin reacted to a comment reply`, 
 "AC_Admin_ProcessCommentResolve": defineMessage`Admin resolved a comment`, 
 "AC_DataformCreateItem": defineMessage`Dataform item created`, 
 "AC_DataformUpdateItem": defineMessage`Dataform item updated`, 
 "AC_DataformSubmitItem": defineMessage`Dataform item submitted`, 
 "AC_DataformDeleteItem": defineMessage`Dataform item deleted`, 
 "AC_DataformCreateSubmitFromAttachment": defineMessage`Item created using IDP connector`, 
 "AC_DataformBatchUpdate": defineMessage`Bulk updated dataform items`, 
 "AC_DataformBatchDelete": defineMessage`Bulk deleted dataform items`, 
 "AC_DataformImport": defineMessage`Bulk import completed`, 
 "AC_DataformExport": defineMessage`Bulk export completed`, 
 "AC_DataformFileDownload": defineMessage`Dataform file downloaded`, 
 "AC_DataformViewUpdateItem": defineMessage`Dataform view item updated`, 
 "AC_DataformViewCreateItem": defineMessage`Dataform view item created`, 
 "AC_DataformViewDeleteItem": defineMessage`Dataform view item deleted`, 
 "AC_DataformViewSubmitItem": defineMessage`Dataform view item submitted`, 
 "AC_DataformViewBatchUpdate": defineMessage`Bulk updated dataform view items`, 
 "AC_DataformViewBatchDelete": defineMessage`Bulk deleted dataform view items`, 
 "AC_DataformViewExport": defineMessage`Bulk export completed`, 
 "AC_DataformViewFileDownload": defineMessage`Dataform view file downloaded`, 
 "AC_PublicFormCreateItem": defineMessage`Public form item created`, 
 "AC_PublicFormUpdateItem": defineMessage`Public form item updated`, 
 "AC_PublicFormSubmitItem": defineMessage`Public form item submitted`, 
 "AC_DataformItemActions": defineMessage`Dataform item actions`, 
 "AC_DataformImportActions": defineMessage`Dataform import`, 
 "AC_DataformBulkActions": defineMessage`Bulk dataform actions`, 
 "AC_DataformExportActions": defineMessage`Dataform export`, 
 "AC_DataformFileDownloadActions": defineMessage`Dataform file actions`, 
 "AC_DataformViewItemActions": defineMessage`Dataform view item actions`, 
 "AC_DataformViewBulkActions": defineMessage`Bulk dataform view actions`, 
 "AC_DataformViewExportActions": defineMessage`Dataform view export`, 
 "AC_DataformViewFileDownloadActions": defineMessage`Dataform view file actions`, 
 "AC_DataformPublicFormActions": defineMessage`Public form item actions`, 
 "AC_IntegrationConnectionCreated": defineMessage`Connection created`, 
 "AC_IntegrationConnectionShared": defineMessage`Connection shared`, 
 "AC_IntegrationConnectionAccessRevoked": defineMessage`Connection revoked`, 
 "AC_IntegrationConnectionDeleted": defineMessage`Connection deleted`, 
 "AC_IntegrationConnectionReconnected": defineMessage`Connection reestablished`, 
 "AC_IntegrationInstanceStatusUpdated": defineMessage`Run status updated`, 
 "AC_IntegrationConnectionAdministration": defineMessage`Connection Administration`, 
 "AC_PortalSettingsAdministration": defineMessage`Portal settings administration`, 
 "AC_PortalSignInPreference": defineMessage`Portal sign in preference`, 
 "AC_PortalDomainUpdated": defineMessage`Updated the portal domain`, 
 "AC_PortalFormatSettingsUpdated": defineMessage`Updated portal format settings`, 
 "AC_PortalSecuritySettingsUpdated": defineMessage`Updated portal security settings`, 
 "AC_PortalIdPLogoUpdated": defineMessage`IdP logo updated`, 
 "AC_PortalOAuthConfigurationCreated": defineMessage`OAuth configuration created`, 
 "AC_PortalOAuthConfigurationUpdated": defineMessage`OAuth configuration updated`, 
 "AC_PortalOAuthConfigurationDeleted": defineMessage`OAuth configuration deleted`, 
 "AuditCode_CreatedEventSubscription": defineMessage`Subscribed to event`, 
 "AuditCode_DeletedEventSubscription": defineMessage`Deleted subscription to event`, 
 "AuditCode_EventSubscription": defineMessage`Event subscription management`, 
 "AuditCode_CaseCreateDefaultItems": defineMessage`Sample items created`, 
 "AuditCode_CaseDeleteDefaultItems": defineMessage`Sample items deleted`, 
 "AuditCode_CaseCreateItem": defineMessage`Item created`, 
 "AuditCode_CaseCloneItem": defineMessage`Item cloned`, 
 "AuditCode_CaseUpdateItem": defineMessage`Item updated`, 
 "AuditCode_CaseUpdateItemDetails": defineMessage`Item updated`, 
 "AuditCode_CaseUpdateItemPosition": defineMessage`Item updated`, 
 "AuditCode_CaseUpdateItemPriority": defineMessage`Item priority updated`, 
 "AuditCode_CaseUpdateItemRequester": defineMessage`Item requester updated`, 
 "AuditCode_CaseUpdateItemDueDate": defineMessage`Item due date updated`, 
 "AuditCode_CaseMoveItem": defineMessage`Item status updated`, 
 "AuditCode_CaseReassignItem": defineMessage`Item assignee updated`, 
 "AuditCode_CaseDeleteItem": defineMessage`Item deleted`, 
 "AC_CaseFormPrint": defineMessage`Form printed`, 
 "AC_CaseFileDownload": defineMessage`File downloaded`, 
 "AC_CaseDataExport": defineMessage`Board exported`, 
 "AC_CaseCreateItemFromAttachment": defineMessage`Item created using IDP connector`, 
 "AuditCode_CaseWatcherAdded": defineMessage`Watcher added`, 
 "AuditCode_CaseWatcherRemoved": defineMessage`Watcher removed`, 
 "AuditCode_CaseExport": defineMessage`Item exported`, 
 "AuditCode_CaseImport": defineMessage`Bulk import completed`, 
 "AuditCode_CaseBatchMove": defineMessage`Statuses of items updated in bulk`, 
 "AuditCode_CaseBatchReassign": defineMessage`Item assignee details updated in bulk`, 
 "AuditCode_CaseBatchDelete": defineMessage`Items deleted in bulk`, 
 "AuditCode_CaseBatchUpdatePriority": defineMessage`Priority of items updated in bulk`, 
 "AuditCode_CaseBatchCreate": defineMessage`Items created in bulk`, 
 "AC_CaseBatchUpdate": defineMessage`Items updated in bulk`, 
 "AC_CaseBatchUpdateSLA": defineMessage`Start/Due dates updated in bulk`, 
 "AuditCode_CaseCreateNote": defineMessage`Item note created`, 
 "AuditCode_CaseUpdateNote": defineMessage`Item note updated`, 
 "AuditCode_CaseDeleteNote": defineMessage`Item note deleted`, 
 "AC_CaseUpdateNotesSummaryPreference": defineMessage`Notes summary preference updated`, 
 "AC_CaseCreateNotesSummary": defineMessage`Summary of item notes created`, 
 "AC_CaseDeleteNotesSummary": defineMessage`Summary of item notes deleted`, 
 "AC_CaseAddNotesSummaryReaction": defineMessage`Reacted to summary of item notes`, 
 "AC_CaseViewCreated": defineMessage`View created`, 
 "AC_CaseViewUpdated": defineMessage`View updated`, 
 "AC_CaseViewDuplicated": defineMessage`View duplicated`, 
 "AC_CaseViewPinned": defineMessage`View pinned`, 
 "AC_CaseViewUnpinned": defineMessage`View unpinned`, 
 "AC_CaseViewDeleted": defineMessage`View deleted`, 
 "AC_CaseCreateSubitem": defineMessage`Subitem created`, 
 "AC_CaseCloneSubitem": defineMessage`Subitem cloned`, 
 "AC_CaseDeleteSubitem": defineMessage`Subitem deleted`, 
 "AC_CaseUpdateSubitem": defineMessage`Subitem updated`, 
 "AC_CaseCreateSubitemNote": defineMessage`Subitem note created`, 
 "AC_CaseUpdateSubitemNote": defineMessage`Subitem note updated`, 
 "AC_CaseCreateSubitemNotesSummary": defineMessage`Summary of subitem notes created`, 
 "AC_CaseDeleteSubitemNotesSummary": defineMessage`Summary of subitem notes deleted`, 
 "AC_CaseAddSubitemNotesSummaryReaction": defineMessage`Reacted to summary of subitem notes`, 
 "AuditCode_CaseBatchCreateSubitem": defineMessage`Subitems created`, 
 "AC_CaseSubflowCreateItems": defineMessage`Orchestration Item Created`, 
 "AC_CaseSubflowCommitItems": defineMessage`Orchestration Item Committed`, 
 "AuditCode_CaseCreation": defineMessage`Item creation`, 
 "AuditCode_CaseActions": defineMessage`Item actions`, 
 "AuditCode_CaseBulkActions": defineMessage`Bulk actions`, 
 "AuditCode_CaseCollaboration": defineMessage`Board collaboration`, 
 "AuditCode_CaseSampleData": defineMessage`Sample item data`, 
 "AuditCode_CaseWatchers": defineMessage`Item watchers`, 
 "AuditCode_CaseAdministration": defineMessage`Item administration`, 
 "AC_CaseView": defineMessage`Views actions`, 
 "AC_FormPrint": defineMessage`Print actions`, 
 "AC_FileDownload": defineMessage`Download actions`, 
 "AC_DataExport": defineMessage`Export actions`, 
 "AC_NoticePublished": defineMessage`Created/updated a notification`, 
 "AC_NoticeUpdated": defineMessage`Configured a notification`, 
 "AC_NotificationAdministration": defineMessage`Notifications`, 
 "AC_ExportActions": defineMessage`Report export actions`, 
 "AC_ProjectReportExport": defineMessage`Project report export`, 
 "AC_UpdatedPreference": defineMessage`Updated the filter/sort preference`, 
 "AC_ExternalDataAction": defineMessage`External data object actions`, 
 "AC_ExternalDataLookup": defineMessage`Looked up external data object`, 
 "AC_ExternalDataListAction": defineMessage`Performed list action in external data object`, 
 "AC_ExternalDataReadAction": defineMessage`Performed read action in external data object`, 
 "AC_ExternalDataCreateAction": defineMessage`Performed create action in external data object`, 
 "AC_ExternalDataUpdateAction": defineMessage`Performed update action in external data object`, 
 "AC_ExternalDataDeleteAction": defineMessage`Performed delete action in external data object`, 
 "AC_ExternalDataGetLookupInstance": defineMessage`Fetched external data object lookup instance`, 
 "AC_CaseReportExport": defineMessage`Report exported`, 
 "AC_DataExport": defineMessage`Export actions`, 
 "AuditCode_ProjectEvent": defineMessage`Sync`, 
 "AuditCode_ProjectTask": defineMessage`Task`, 
 "AuditCode_ProjectTaskBatch": defineMessage`Task batch`, 
 "AuditCode_ProjectViewTask": defineMessage`View task`, 
 "AuditCode_ProjectViewTaskBatch": defineMessage`View task batch`, 
 "AuditCode_ProjectTaskImport": defineMessage`Task import`, 
 "AuditCode_ProjectTaskWatcher": defineMessage`Task watcher`, 
 "AuditCode_ProjectSubtask": defineMessage`Subtask`, 
 "AuditCode_ProjectTaskNote": defineMessage`Task note`, 
 "AuditCode_ProjectStepWatcher": defineMessage`Step watcher`, 
 "AuditCode_ProjectEventHandled": defineMessage`Sync data update`, 
 "AuditCode_ProjectTaskCreated": defineMessage`Task created`, 
 "AuditCode_ProjectTaskUpdated": defineMessage`Task updated`, 
 "AuditCode_ProjectTaskArchived": defineMessage`Task archived`, 
 "AuditCode_ProjectTaskUnarchived": defineMessage`Task unarchived`, 
 "AuditCode_ProjectTaskDeleted": defineMessage`Task deleted`, 
 "AuditCode_ProjectTaskBatchCreated": defineMessage`Task created`, 
 "AuditCode_ProjectTaskBatchUpdated": defineMessage`Task updated`, 
 "AuditCode_ProjectTaskBatchMoved": defineMessage`Task moved`, 
 "AuditCode_ProjectTaskBatchAssigned": defineMessage`Task assigned`, 
 "AuditCode_ProjectTaskBatchArchived": defineMessage`Task archived`, 
 "AuditCode_ProjectTaskBatchUnarchived": defineMessage`Task unarchived`, 
 "AuditCode_ProjectTaskBatchDeleted": defineMessage`Task deleted`, 
 "AuditCode_ProjectViewTaskUpdated": defineMessage`Task updated`, 
 "AuditCode_ProjectViewTaskBatchUpdated": defineMessage`Task updated`, 
 "AuditCode_ProjectViewTaskBatchMoved": defineMessage`Task moved`, 
 "AuditCode_ProjectViewTaskBatchAssigned": defineMessage`Task assigned`, 
 "AuditCode_ProjectViewTaskBatchDeleted": defineMessage`Task deleted`, 
 "AuditCode_ProjectTaskImported": defineMessage`Task imported`, 
 "AuditCode_ProjectTaskWatcherAdded": defineMessage`A watcher was added to a task`, 
 "AuditCode_ProjectTaskWatcherRemoved": defineMessage`A watcher was removed from a task`, 
 "AuditCode_ProjectSubtaskCreated": defineMessage`Subtask created`, 
 "AuditCode_ProjectSubtaskUpdated": defineMessage`Subtask updated`, 
 "AuditCode_ProjectSubtaskDeleted": defineMessage`Subtask deleted`, 
 "AuditCode_ProjectSubtaskConvertedToTask": defineMessage`Subtask converted to a task`, 
 "AuditCode_ProjectTaskNoteCreated": defineMessage`Note added in a task`, 
 "AuditCode_ProjectTaskNoteUpdated": defineMessage`Note in the task is updated`, 
 "AuditCode_ProjectTaskNoteDeleted": defineMessage`Note deleted from a task`, 
 "AuditCode_ProjectStepWatcherCreated": defineMessage`A watcher was added to a step`, 
 "AuditCode_ProjectStepWatcherRemoved": defineMessage`A watcher was removed from a step`, 
 "AuditCode_ProcessMetaPublishPreview": defineMessage`Workflow simulated`, 
 "AuditCode_ProcessMetaPublish": defineMessage`Process published`, 
 "AuditCode_ProcessMetaSaveDraft": defineMessage`Process draft saved`, 
 "AuditCode_ProcessMetaDuplicate": defineMessage`Process duplicated`, 
 "AuditCode_ProcessMetaArchive": defineMessage`Process archived`, 
 "AuditCode_ProcessMetaUnarchive": defineMessage`Process unarchived`, 
 "AuditCode_ProcessMetaDelete": defineMessage`Process deleted`, 
 "AuditCode_ProcessMetaAcquire": defineMessage`Process lock acquired`, 
 "AuditCode_ProcessMetaDiscard": defineMessage`Process changes discarded`, 
 "AC_ProcessTranslationMetaSaveDraft": defineMessage`Saved Process translation metadata`, 
 "AuditCode_ProcessAdministration": defineMessage`Process administration`, 
 "AC_ProcessDocumentContentGenerated": defineMessage`Draft generated using AI`, 
 "AC_ProcessDocumentContentRegenerated": defineMessage`Draft regenerated using AI`, 
 "AuditCode_CaseMetaSaveDraft": defineMessage`Board form updated`, 
 "AuditCode_CaseMetaPublish": defineMessage`Board published`, 
 "AuditCode_CaseMetaDuplicate": defineMessage`Board duplicated`, 
 "AuditCode_CaseMetaAcquire": defineMessage`Unpublished changes saved`, 
 "AuditCode_CaseMetaDiscard": defineMessage`Unpublished changes discarded`, 
 "AuditCode_CaseMetaTriggerVersioning": defineMessage`Form field version updated`, 
 "AC_CaseTranslationMetaSaveDraft": defineMessage`Saved Board translation metadata`, 
 "AuditCode_CaseWorkflowMetaSaveDraft": defineMessage`Workflow settings updated`, 
 "AuditCode_CaseReportMetaSaveDraft": defineMessage`Report updated`, 
 "AuditCode_CaseAdministration": defineMessage`Board administration`, 
 "AuditCode_ProjectAdministration": defineMessage`Project administration`, 
 "AuditCode_ProjectViewAdministration": defineMessage`View administration`, 
 "AuditCode_ProjectReportAdministration": defineMessage`Report administration`, 
 "AuditCode_ProjectMetaCreated": defineMessage`Project created`, 
 "AuditCode_ProjectMetaDraftSaved": defineMessage`Project form updated`, 
 "AuditCode_ProjectMetaPublished": defineMessage`Project published`, 
 "AuditCode_ProjectMetaSoftPublished": defineMessage`Project published`, 
 "AuditCode_ProjectMetaRepublished": defineMessage`Project published`, 
 "AuditCode_ProjectMetaDuplicated": defineMessage`Project duplicated`, 
 "AuditCode_ProjectMetaDeleted": defineMessage`Project deleted`, 
 "AuditCode_ProjectMetaAcquired": defineMessage`Unpublished changes saved`, 
 "AuditCode_ProjectMetaDiscarded": defineMessage`Unpublished changes discarded`, 
 "AuditCode_ProjectMetaVersioningTriggered": defineMessage`Form field version updated`, 
 "AuditCode_ProjectWorkflowMetaDraftSaved": defineMessage`Project configuration updated`, 
 "AuditCode_ProjectViewMetaCreated": defineMessage`View created`, 
 "AuditCode_ProjectViewMetaDraftSaved": defineMessage`View configuration updated`, 
 "AuditCode_ProjectViewMetaSoftPublished": defineMessage`View updated`, 
 "AuditCode_ProjectReportMetaCreated": defineMessage`Report created`, 
 "AuditCode_ProjectReportMetaDraftSaved": defineMessage`Report configuration updated`, 
 "AuditCode_ProjectReportMetaSoftPublished": defineMessage`Report updated`, 
 "AuditCode_ProjectReportMetaDuplicated": defineMessage`Report duplicated`, 
 "AC_DatasetMetaPublish": defineMessage`Dataset published`, 
 "AC_DatasetMetaSoftPublish": defineMessage`Dataset soft published`, 
 "AC_DatasetMetaDuplicate": defineMessage`Dataset duplicated`, 
 "AC_DatasetMetaDelete": defineMessage`Dataset deleted`, 
 "AC_DatasetViewMetaCreated": defineMessage`View created`, 
 "AC_DatasetViewMetaSoftPublished": defineMessage`View soft published`, 
 "AC_DatasetAdministration": defineMessage`Dataset administration`, 
 "AC_ApplicationAdministration": defineMessage`Application administration`, 
 "AC_ApplicationTranslationMetaSaveDraft": defineMessage`Application language updated`, 
 "AC_DataformMetaSaveDraft": defineMessage`Dataform metadata updated`, 
 "AC_DataformMetaPublish": defineMessage`Dataform metadata published`, 
 "AC_DataformMetaDuplicate": defineMessage`Dataform metadata duplicated`, 
 "AC_DataformMetaAcquire": defineMessage`Unpublished changes saved`, 
 "AC_DataformMetaDiscard": defineMessage`Unpublished changes discarded`, 
 "AC_DataformMetaTriggerVersioning": defineMessage`Dataform field version updated`, 
 "AC_DataformTranslationMetaSaveDraft": defineMessage`Saved dataform translation metadata`, 
 "AC_DataformAdministration": defineMessage`Dataform administration`, 
 "AC_ExportTemplate": defineMessage`Template export complete`, 
 "AC_ImportTemplate": defineMessage`Template import complete`, 
 "AC_ExportPrivateTemplate": defineMessage`Template export complete`, 
 "AC_ImportPrivateTemplate": defineMessage`Template import complete`, 
 "AuditCode_UploadLocalStorage": defineMessage`Uploaded file from local storage`, 
 "AuditCode_UploadGoogleDrive": defineMessage`Uploaded file from Google Drive`, 
 "AuditCode_UploadOneDrive": defineMessage`Uploaded file from OneDrive`, 
 "AuditCode_UploadDropbox": defineMessage`Uploaded file from Dropbox`, 
 "AuditCode_UploadBox": defineMessage`Uploaded file from Box`, 
 "AuditCode_LoginGoogleDrive": defineMessage`Logged into Google Drive`, 
 "AuditCode_LoginOneDrive": defineMessage`Logged into OneDrive`, 
 "AuditCode_LoginDropbox": defineMessage`Logged into Dropbox`, 
 "AuditCode_LoginBox": defineMessage`Logged into Box`, 
 "AuditCode_FilesAdministration": defineMessage`Files administration`, 
 "AC_AdminPlanCreated": defineMessage`Plan for administrator created`, 
 "AC_AdminPlanUpdated": defineMessage`Plan for administrator updated`, 
 "AC_PlanCreated": defineMessage`Plan created`, 
 "AC_PlanUpdated": defineMessage`Plan updated`, 
 "AC_PlansUpdated": defineMessage`Plans updated in bulk`, 
 "AC_PlanDeleted": defineMessage`Plan deleted`, 
 "AC_AddonCreated": defineMessage`Add-on created`, 
 "AC_AddonUpdated": defineMessage`Add-on updated`, 
 "AC_AddonDeleted": defineMessage`Add-on deleted`, 
 "AC_CatalogsUpdated": defineMessage`Catalog details updated`, 
 "AC_AccountCreated": defineMessage`Account created`, 
 "AC_SandboxAccountCreated": defineMessage`Sandbox environment created`, 
 "AC_SandboxAccountDeleted": defineMessage`Sandbox environment deleted`, 
 "AC_AccountDomainUpdated": defineMessage`Account domain updated`, 
 "AC_AccountDomainReclaimed": defineMessage`Account domain reclaimed`, 
 "AC_AccountAliasDomainAdded": defineMessage`Alias domain added`, 
 "AC_AccountAliasDomainDeleted": defineMessage`Alias domain deleted`, 
 "AuditCode_UpdatedAccountHoliday": defineMessage`Updated account holidays`, 
 "AC_HolidayUpdated": defineMessage`Holiday updated`, 
 "AuditCode_UpdatedAccountName": defineMessage`Updated account name`, 
 "AuditCode_UpdatedCustomDomain": defineMessage`Updated custom domain details`, 
 "AuditCode_UpdatedAssociatedDomain": defineMessage`Updated associated email domain details`, 
 "AuditCode_DeletedAssociatedDomain": defineMessage`Deleted associated email domain`, 
 "AuditCode_UpdatedFlowSetting": defineMessage`Updated flow settings`, 
 "AuditCode_UpdatedLowcodeSetting": defineMessage`Updated lowcode settings`, 
 "AuditCode_TransferredAccountOwner": defineMessage`Transferred account owner`, 
 "AuditCode_UpdatedAccountDetails": defineMessage`Updated account details`, 
 "AuditCode_RemovedSAMLConfig": defineMessage`Removed SAML configuration`, 
 "AuditCode_UpdatedSCIMConfig": defineMessage`Updated SCIM configuration`, 
 "AuditCode_DeletedSCIMConfig": defineMessage`Deleted SCIM configuration`, 
 "AuditCode_UpdatedUserSync": defineMessage`Updated user sync configuration`, 
 "AuditCode_DeletedUserSync": defineMessage`Deleted user sync configuration`, 
 "AuditCode_ResendEmailDomainVerification": defineMessage`Resent email verification for associated domain config`, 
 "AuditCode_UpdatedSandboxEnvironment": defineMessage`Updated sandbox domain details`, 
 "AC_LicenseInformationUpdated": defineMessage`License information updated`, 
 "AC_LicenseActivated": defineMessage`License activated`, 
 "AC_LicenseCanceled": defineMessage`License canceled`, 
 "AC_LicenseReactivated": defineMessage`License reactivated`, 
 "AC_BackupConfigUpdated": defineMessage`Data backup configuration updated`, 
 "AC_BackupConfigDeleted": defineMessage`Data backup configuration deleted`, 
 "AC_BackupRequestCreated": defineMessage`Data backup in queue`, 
 "AC_BackupRequestCanceled": defineMessage`Data backup canceled while in queue`, 
 "AC_BackupStatusChanged": defineMessage`Data backup status updated`, 
 "AC_BackupHistoryCreated": defineMessage`Data backup completed`, 
 "AC_BotSettingsUpdated": defineMessage`Bot settings updated`, 
 "AC_CustomMailConfigUpdated": defineMessage`Custom email configuration updated`, 
 "AC_CustomMailConfigDeleted": defineMessage`Custom email configuration deleted`, 
 "AC_SystemAdministration": defineMessage`System administration`, 
 "AC_AccountSandboxAdministration": defineMessage`Account sandbox administration`, 
 "AuditCode_HolidaysAdministration": defineMessage`Holidays administration`, 
 "AuditCode_BillingAdministration": defineMessage`Billing administration`, 
 "AuditCode_AccountSettingsAdministration": defineMessage`Account settings administration`, 
 "AuditCode_FlowSettingsAdministration": defineMessage`Flow settings administration`, 
 "AuditCode_LowcodeSettingsAdministration": defineMessage`Low code settings administration`, 
 "AuditCode_PreferenceAdministration": defineMessage`Sign-in preference administration`, 
 "AuditCode_UserProvisioningAdministration": defineMessage`User provisioning administration`, 
 "AC_AccountBackupAdministration": defineMessage`Data backup administration`, 
 "AC_MailConfigAdministration": defineMessage`Email configuration administration`, 
 "AuditCode_ProcessFlowCreate": defineMessage`Process created`, 
 "AuditCode_ProcessFlowAddFavorite": defineMessage`Process added to favorites`, 
 "AuditCode_ProcessFlowRemoveFavorite": defineMessage`Process removed from favorites`, 
 "AuditCode_ProcessFlowUpdateDetail": defineMessage`Process updated`, 
 "AuditCode_ProcessFlowDuplicate": defineMessage`Process duplicated`, 
 "AuditCode_ProcessFlowArchive": defineMessage`Process archived`, 
 "AuditCode_ProcessFlowUnarchive": defineMessage`Process unarchived`, 
 "AuditCode_ProcessFlowDelete": defineMessage`Process deleted`, 
 "AuditCode_ProcessFlowBatchAddMemeber": defineMessage`Member(s) added to process`, 
 "AuditCode_ProcessFlowRemoveMemeber": defineMessage`Member(s) removed from process`, 
 "AuditCode_ProcessFlowUpdateMember": defineMessage`User permission updated`, 
 "AuditCode_ProcessFlowUpdateSetting": defineMessage`Process settings updated`, 
 "AuditCode_ProcessFlowUpdateSecuritySetting": defineMessage`Process security settings updated`, 
 "AuditCode_ProcessFlowSaveCardSetting": defineMessage`Process card settings updated`, 
 "AuditCode_ProcessFlowResetCounter": defineMessage`Counter reset`, 
 "AuditCode_ProcessApproveFlow": defineMessage`Process approved by admin`, 
 "AC_ProcessFlowUpdateTranslation": defineMessage`Updated Process translation`, 
 "AC_ProcessFlowAddTranslationLanguage": defineMessage`Added Process translation language`, 
 "AC_ProcessUpdateTranslationLanguage": defineMessage`Updated Process translation language`, 
 "AuditCode_ProcessAdministration": defineMessage`Process administration`, 
 "AC_ProcessUpdatePublicFormSettings": defineMessage`Public form settings updated`, 
 "AC_ProcessDocumentEventHandled": defineMessage`Template details updated`, 
 "AC_ProcessDocumentCreatedFromSuggestion": defineMessage`Template created using AI`, 
 "AuditCode_CaseFlowCreate": defineMessage`Board created`, 
 "AuditCode_CaseFlowAICreate": defineMessage`Board created using AI`, 
 "AuditCode_CaseFlowUpdateDetails": defineMessage`Board updated`, 
 "AuditCode_CaseFlowAddFavourite": defineMessage`Board added to favourites`, 
 "AuditCode_CaseFlowRemoveFavourite": defineMessage`Board removed from favourites`, 
 "AuditCode_CaseFlowDelete": defineMessage`Board deleted`, 
 "AuditCode_CaseFlowArchive": defineMessage`Board archived`, 
 "AuditCode_CaseFlowUnarchive": defineMessage`Board unarchived`, 
 "AuditCode_CaseFlowDuplicate": defineMessage`Board duplicated`, 
 "AuditCode_CaseFlowBatchAddMembers": defineMessage`Member(s) added to the board`, 
 "AuditCode_CaseFlowRemoveMember": defineMessage`Member(s) removed from the board`, 
 "AuditCode_CaseFlowUpdateMember": defineMessage`User permission updated`, 
 "AuditCode_CaseFlowUpdateSecuritySettings": defineMessage`Security settings updated`, 
 "AuditCode_CaseFlowUpdateSettings": defineMessage`Board settings updated`, 
 "AuditCode_CaseFlowApproveFlow": defineMessage`Flow approved`, 
 "AC_CaseFlowUpdateTranslation": defineMessage`Updated Board translation`, 
 "AC_CaseFlowAddTranslationLanguage": defineMessage`Added Board translation language`, 
 "AC_CaseUpdateTranslationLanguage": defineMessage`Updated Board translation language`, 
 "AuditCode_CaseReportFlowCreate": defineMessage`Report created`, 
 "AuditCode_CaseReportFlowUpdateDetails": defineMessage`Report updated`, 
 "AuditCode_CaseReportFlowDuplicate": defineMessage`Report duplicated`, 
 "AuditCode_CaseReportFlowDelete": defineMessage`Report deleted`, 
 "AuditCode_CaseReportFlowBatchAddMembers": defineMessage`Member(s) added to report`, 
 "AuditCode_CaseReportFlowRemoveMember": defineMessage`Member(s) removed from report`, 
 "AuditCode_CaseReportFlowUpdateMember": defineMessage`User permission updated`, 
 "AuditCode_CaseAdministration": defineMessage`Board administration`, 
 "AC_CaseMetricAdministration": defineMessage`Board Metric administration`, 
 "AC_CaseMetricMemberAdded": defineMessage`Member(s) added to the report`, 
 "AC_CaseMetricMemberRemoved": defineMessage`Member(s) removed from the report`, 
 "AC_CaseMetricCreated": defineMessage`Default system metric created`, 
 "AuditCode_ProjectAdministration": defineMessage`Project administration`, 
 "AuditCode_ProjectViewAdministration": defineMessage`View administration`, 
 "AuditCode_ProjectMetricAdministration": defineMessage`Report administration`, 
 "AuditCode_ProjectReportAdministration": defineMessage`Report administration`, 
 "AuditCode_ProjectCreated": defineMessage`Project created`, 
 "AuditCode_ProjectUpdated": defineMessage`Project updated`, 
 "AuditCode_ProjectAddedToFavorites": defineMessage`Project added to favorites`, 
 "AuditCode_ProjectRemovedFromFavorites": defineMessage`Project removed from favorites`, 
 "AuditCode_ProjectDuplicated": defineMessage`Project duplicated`, 
 "AuditCode_ProjectArchived": defineMessage`Project archived`, 
 "AuditCode_ProjectUnarchived": defineMessage`Project unarchived`, 
 "AuditCode_ProjectDeleted": defineMessage`Project deleted`, 
 "AuditCode_ProjectMemberAdded": defineMessage`Member(s) added to the project`, 
 "AuditCode_ProjectMemberRemoved": defineMessage`Member(s) removed from the project`, 
 "AuditCode_ProjectMemberUpdated": defineMessage`Project member updated`, 
 "AuditCode_ProjectSecuritySettingsUpdated": defineMessage`Security settings updated`, 
 "AuditCode_ProjectSettingsUpdated": defineMessage`Project settings updated`, 
 "AuditCode_ProjectApproved": defineMessage`Project approved`, 
 "AuditCode_ProjectImportStatusUpdated": defineMessage`Project updated`, 
 "AuditCode_ProjectViewCreated": defineMessage`View created`, 
 "AuditCode_ProjectViewUpdated": defineMessage`View updated`, 
 "AuditCode_ProjectViewDeleted": defineMessage`View deleted`, 
 "AuditCode_ProjectMetricCreated": defineMessage`Default metric report created`, 
 "AuditCode_ProjectMetricMemberAdded": defineMessage`Member(s) added to the report`, 
 "AuditCode_ProjectMetricMemberUpdated": defineMessage`Report member updated`, 
 "AuditCode_ProjectMetricMemberRemoved": defineMessage`Member(s) removed from the report`, 
 "AuditCode_ProjectReportCreated": defineMessage`Report created`, 
 "AuditCode_ProjectReportUpdated": defineMessage`Report updated`, 
 "AuditCode_ProjectReportDuplicated": defineMessage`Report duplicated`, 
 "AuditCode_ProjectReportDeleted": defineMessage`Report deleted`, 
 "AuditCode_ProjectReportMemberAdded": defineMessage`Member(s) added to the report`, 
 "AuditCode_ProjectReportMemberUpdated": defineMessage`Report member updated`, 
 "AuditCode_ProjectReportMemberRemoved": defineMessage`Member(s) removed from the report`, 
 "AC_IntegrationCreated": defineMessage`Integration created`, 
 "AC_IntegrationActivated": defineMessage`Integration turned on`, 
 "AC_IntegrationDeactivated": defineMessage`Integration turned off`, 
 "AC_IntegrationDeleted": defineMessage`Integration deleted`, 
 "AC_IntegrationDetailsUpdated": defineMessage`Integration details updated`, 
 "AC_IntegrationArchived": defineMessage`Integration archived`, 
 "AC_IntegrationUnarchived": defineMessage`Integration unarchived`, 
 "AC_IntegrationDuplicated": defineMessage`Integration duplicated`, 
 "AC_IntegrationAccessShared": defineMessage`Integration shared with member`, 
 "AC_IntegrationAccessRevoked": defineMessage`Member removed from integration`, 
 "AC_IntegrationFlowUpdateSecuritySettings": defineMessage`Security settings updated`, 
 "AC_IntegrationFlowCustomTriggerEnabled": defineMessage`Custom trigger enabled`, 
 "AC_IntegrationFlowCustomTriggerDisabled": defineMessage`Custom trigger disabled`, 
 "AC_IntegrationFlowCustomTriggerDefinitionUpdated": defineMessage`Custom trigger input fields updated`, 
 "AC_IntegrationStatusChanged": defineMessage`Integration status updated`, 
 "AC_IntegrationAdministration": defineMessage`Integration Administration`, 
 "AC_DatasetFlowCreated": defineMessage`Dataset created`, 
 "AC_DatasetFlowUpdateDetails": defineMessage`Dataset updated`, 
 "AC_DatasetFlowAddFavourite": defineMessage`Dataset added to favorites`, 
 "AC_DatasetFlowRemoveFavourite": defineMessage`Dataset removed from favorites`, 
 "AC_DatasetFlowDelete": defineMessage`Dataset deleted`, 
 "AC_DatasetFlowArchive": defineMessage`Dataset archived`, 
 "AC_DatasetFlowUnarchive": defineMessage`Dataset unarchived`, 
 "AC_DatasetFlowDuplicate": defineMessage`Dataset duplicated`, 
 "AC_DatasetFlowBatchAddMembers": defineMessage`Member(s) added to the dataset`, 
 "AC_DatasetFlowRemoveMember": defineMessage`Member(s) removed from the dataset`, 
 "AC_DatasetFlowUpdateMember": defineMessage`User permission updated`, 
 "AC_DatasetFlowUpdateSecuritySettings": defineMessage`Security settings updated`, 
 "AC_DatasetFlowUpdateSettings": defineMessage`Dataset settings updated`, 
 "AC_DatasetFlowApproveFlow": defineMessage`Flow approved`, 
 "AC_DatasetFlowGrantAppAccess": defineMessage`App access granted`, 
 "AC_DatasetViewFlowCreate": defineMessage`View created`, 
 "AC_DatasetViewFlowUpdateDetails": defineMessage`View updated`, 
 "AC_DatasetViewFlowDuplicate": defineMessage`View duplicated`, 
 "AC_DatasetViewFlowDelete": defineMessage`View deleted`, 
 "AC_DatasetViewFlowBatchAddMembers": defineMessage`Member(s) added to view`, 
 "AC_DatasetViewFlowRemoveMember": defineMessage`Member(s) removed from view`, 
 "AC_DatasetViewFlowUpdateMember": defineMessage`User permission updated`, 
 "AC_DatasetViewFlowUpdateSettings": defineMessage`View settings updated`, 
 "AC_DatasetAdministration": defineMessage`Dataset administration`, 
 "AC_PortalAdminAdded": defineMessage`Added a Portal Admin`, 
 "AC_PortalAdminRemoved": defineMessage`Removed a Portal Admin`, 
 "AC_PortalUserRoleUpdated": defineMessage`Updated portal user's role`, 
 "AC_PortalCreated": defineMessage`Created a portal`, 
 "AC_PortalEnabled": defineMessage`Enabled a portal`, 
 "AC_PortalDisabled": defineMessage`Disabled a portal`, 
 "AC_PortalPreviewFlows": defineMessage`Previewed newly added and modified flows`, 
 "AC_PortalDeployInitiated": defineMessage`Initiated the deployment process`, 
 "AC_PortalDeployCompleted": defineMessage`Completed the deployment`, 
 "AC_PortalRoleAdministration": defineMessage`Portal role administration`, 
 "AC_PortalAdministration": defineMessage`Portal administration`, 
 "AC_PortalDeployment": defineMessage`Portal Deployment`, 
 "AC_ApplicationAdministration": defineMessage`Application administration`, 
 "AC_ApplicationDeployment": defineMessage`Application Deployment`, 
 "AC_ApplicationFlowUpdateTranslation": defineMessage`Translation settings updated`, 
 "AC_ApplicationUpdateTranslationLanguage": defineMessage`Translation language settings updated`, 
 "AC_ApplicationUpdatePageAccess": defineMessage`Update application page access`, 
 "AC_ApplicationPreviewFlows": defineMessage`Previewed newly added and modified flows`, 
 "AC_ApplicationDeployInitiated": defineMessage`Initiated the deployment process`, 
 "AC_ApplicationDeployCompleted": defineMessage`Completed the deployment`, 
 "AC_DataformFlowCreate": defineMessage`Dataform created`, 
 "AC_DataformFlowUpdateDetails": defineMessage`Dataform updated`, 
 "AC_DataformFlowDelete": defineMessage`Dataform deleted`, 
 "AC_DataformFlowArchive": defineMessage`Dataform archived`, 
 "AC_DataformFlowUnarchive": defineMessage`Dataform unarchived`, 
 "AC_DataformFlowDuplicate": defineMessage`Dataform duplicated`, 
 "AC_DataformFlowBatchAddMembers": defineMessage`Member(s) added to a dataform`, 
 "AC_DataformFlowRemoveMember": defineMessage`Member(s) removed from a dataform`, 
 "AC_DataformFlowUpdateMember": defineMessage`Updated dataform user permission`, 
 "AC_DataformFlowUpdateSecuritySettings": defineMessage`Updated dataform security settings`, 
 "AC_DataformFlowUpdateSettings": defineMessage`Dataform settings updated`, 
 "AC_DataformFlowUpdateTranslation": defineMessage`Updated dataform translation settings`, 
 "AC_DataformFlowAddTranslationLanguage": defineMessage`Added dataform translation language`, 
 "AC_DataformFlowUpdateTranslationLanguage": defineMessage`Updated dataform translation language`, 
 "AC_DataformViewFlowCreate": defineMessage`Dataform view created`, 
 "AC_DataformViewFlowUpdateDetails": defineMessage`Dataform view updated`, 
 "AC_DataformViewFlowDuplicate": defineMessage`Dataform view duplicated`, 
 "AC_DataformViewFlowDelete": defineMessage`Dataform view deleted`, 
 "AC_DataformViewFlowBatchAddMembers": defineMessage`Member(s) added to a dataform view`, 
 "AC_DataformViewFlowRemoveMember": defineMessage`Member(s) removed from a dataform view`, 
 "AC_DataformViewFlowUpdateMember": defineMessage`Updated dataform view user permission`, 
 "AC_DataformViewFlowUpdateSettings": defineMessage`Updated dataform view settings`, 
 "AC_FormReportFlowCreate": defineMessage`Dataform report created`, 
 "AC_FormReportFlowUpdateDetails": defineMessage`Dataform report updated`, 
 "AC_FormReportFlowDuplicate": defineMessage`Dataform report duplicated`, 
 "AC_FormReportFlowDelete": defineMessage`Dataform report deleted`, 
 "AC_FormReportFlowBatchAddMembers": defineMessage`Member(s) added to a dataform report`, 
 "AC_FormReportFlowRemoveMember": defineMessage`Member(s) removed from a dataform report`, 
 "AC_FormReportFlowUpdateMember": defineMessage`Updated dataform report user permission`, 
 "AC_DataformAdministration": defineMessage`Dataform administration`, 
 "AC_ListAdministration": defineMessage`List administration`, 
 "AC_ListItemsUpdated": defineMessage`List items updated`, 
 "AC_ListItemsUpdatedFromWorkflow": defineMessage`List items updated from Kissflow workflows`, 
 "AC_ListBatchFetchOrCreate": defineMessage`List created`, 
 "AC_DataExport": defineMessage`Export actions`, 
 "AC_ProcessReportExport": defineMessage`Report exported`, 
 "AC_CustomComponentLimitUpdated": defineMessage`Updated the custom component limit`, 
 "AC_ApplicationAdministration": defineMessage`Application administration`, 
 "AC_HolidayCreated": defineMessage`Holiday created`, 
 "AC_HolidayUpdated": defineMessage`Holiday updated`, 
 "AC_HolidayDeleted": defineMessage`Holiday deleted`, 
 "AC_WeekendUpdated": defineMessage`Weekend updated`, 
 "AC_MailConfigCreated": defineMessage`Email configuration created`, 
 "AC_MailConfigUpdated": defineMessage`Email configuration updated`, 
 "AC_MailConfigDeleted": defineMessage`Email configuration deleted`, 
 "AC_MailConfigEnabledDisabled": defineMessage`Email configuration enabled/disabled`, 
 "AC_MailConfigValidated": defineMessage`Email configuration validated`, 
 "AuditCode_HolidaysAdministration": defineMessage`Holiday administration`, 
 "AC_MailConfigAdministration": defineMessage`Email configuration administration`, 
 "AuditCode_DefaultEventType": defineMessage`Performed an action`, 
 "AuditCode_DefaultEventCategory": defineMessage`Unclassified event`, 
 "AuditCode_DataEvent": defineMessage`Data write event`, 
 "AC_IntegrationInstanceRerun": defineMessage`Integration rerun`, 
 "AuditCode_APICreatedAccessKey": defineMessage`Created an access key`, 
 "AuditCode_APIUpdatedAccessKey": defineMessage`Updated access key details`, 
 "AuditCode_APIDeletedAccessKey": defineMessage`Deleted the access key`, 
 "AuditCode_CreatedGroup": defineMessage`Created a group`, 
 "AuditCode_UpdatedGroup": defineMessage`Updated the group details`, 
 "AuditCode_DeletedGroup": defineMessage`Deleted the group`, 
 "AuditCode_BatchCreatedGroup": defineMessage`Created group(s) through user provisioning`, 
 "AuditCode_AddedMemberToGroup": defineMessage`Added member in the group through user provisioning`, 
 "AuditCode_CreatedRole": defineMessage`Created a role`, 
 "AuditCode_UpdatedRole": defineMessage`Updated the role`, 
 "AuditCode_DeletedRole": defineMessage`Deleted the role`, 
 "AuditCode_CreatedBatchRole": defineMessage`Bulk created or Updated user roles`, 
 "AC_UpdatedBatchExternalRole": defineMessage`Bulk updated external role`, 
 "AC_RemovedExternalRole": defineMessage`Removed external role`, 
 "AuditCode_CreatedUser": defineMessage`Added a user`, 
 "AuditCode_UpdatedUser": defineMessage`Updated the user details`, 
 "AuditCode_CancelledDelegation": defineMessage`Cancelled task delegation`, 
 "AuditCode_UpdatedUserPreference": defineMessage`Updated user preference`, 
 "AuditCode_UpdatedUserProfile": defineMessage`Updated user profile`, 
 "AuditCode_UpdatedUserDetail": defineMessage`Updated user details`, 
 "AuditCode_ActivatedUser": defineMessage`Activated user`, 
 "AuditCode_DeactivatedUser": defineMessage`Deactivated user`, 
 "AuditCode_ResetUserPassword": defineMessage`Reset password mail sent`, 
 "AuditCode_ResetVerificationEmail": defineMessage`Resent verification email`, 
 "AuditCode_BulkResetVerificationEmail": defineMessage`Bulk resent verification email`, 
 "AuditCode_UpdatedUserDetailExtended": defineMessage`Updated user details (extended)`, 
 "AuditCode_BulkUpdatedUserDetailExtended": defineMessage`Bulk updated user details (extended)`, 
 "AuditCode_AddedPreference": defineMessage`Added filter/sort preference`, 
 "AuditCode_UpdatedPreference": defineMessage`Updated the filter/sort preference`, 
 "AuditCode_DeletedPreference": defineMessage`Deleted the filter/sort preference`, 
 "AuditCode_SAMLLogin": defineMessage`Logged in through SAML`, 
 "AuditCode_KissflowLogin": defineMessage`Logged in through Kissflow credentials`, 
 "AuditCode_SSOLogin": defineMessage`Logged in through SSO`, 
 "AuditCode_UserSession": defineMessage`Deleted a user session`, 
 "AuditCode_BulkDeletedUser": defineMessage`Bulk deleted user sessions`, 
 "AuditCode_Join": defineMessage`Signed up through invite url`, 
 "AC_AdminSetUserPassword": defineMessage`User password updated`, 
 "AuditCode_ForgotPassword": defineMessage`Requested new password (forgot password)`, 
 "AuditCode_Logout": defineMessage`Logged out`, 
 "AuditCode_SCIMUserUpdated": defineMessage`Updated user details (SCIM)`, 
 "AuditCode_SCIMUserCreated": defineMessage`Added a user (SCIM)`, 
 "AuditCode_SCIMUserDeleted": defineMessage`Deleted user (SCIM)`, 
 "AuditCode_SCIMGroupCreated": defineMessage`Created a group (SCIM)`, 
 "AuditCode_SCIMGroupUpdated": defineMessage`Updated group details (SCIM)`, 
 "AuditCode_SCIMGroupDeleted": defineMessage`Deleted the group (SCIM)`, 
 "AuditCode_SYNCGroupCreated": defineMessage`Created a group (User and Group Sync)`, 
 "AuditCode_SYNCGroupUpdated": defineMessage`Updated group details (User and Group Sync)`, 
 "AuditCode_SYNCGroupDeleted": defineMessage`Deleted group (User and Group Sync)`, 
 "AuditCode_SYNCBatchUserUpdated": defineMessage`Batch updated user details (User and Group Sync)`, 
 "AuditCode_CreatedSystemAccessKey": defineMessage`Created system access key`, 
 "AuditCode_AccessKeyAdministration": defineMessage`Access keys administration`, 
 "AuditCode_UserAdministration": defineMessage`User administration`, 
 "AC_ServiceAccountAdmin": defineMessage`Service account administration`, 
 "AuditCode_EmployeeManagement": defineMessage`Employee Management`, 
 "AuditCode_GroupAdministration": defineMessage`Group administration`, 
 "AuditCode_RolesAdministration": defineMessage`Roles administration`, 
 "AuditCode_UserPreference": defineMessage`User preference`, 
 "AuditCode_UserProfileAdministration": defineMessage`User profile administration`, 
 "AuditCode_ExtendedUserAdministration": defineMessage`User administration (Extended)`, 
 "AuditCode_UserActivity": defineMessage`User activity`, 
 "AC_ExportedUsersDownloaded": defineMessage`User data downloaded`, 
 "AC_UsersExportInitiated": defineMessage`User Export Initiated`, 
 "AC_TaskDelegation": defineMessage`Admin task delegation`, 
 "AC_AdminCreateDelegation": defineMessage`Admin task delegation created`, 
 "AC_AdminUpdateDelegation": defineMessage`Admin task delegation updated`, 
 "AC_AdminBatchUpdateDelegation": defineMessage`Admin task delegations updated in bulk`, 
 "AC_UserCreateDelegation": defineMessage`User task delegation created`, 
 "AC_UserUpdateDelegation": defineMessage`User task delegation updated`, 
 "AC_ServiceAccountCreated": defineMessage`Service account created`, 
 "AC_ServiceAccountDeleted": defineMessage`Service account deleted`, 
 "AC_ServiceAccountDetailsUpdated": defineMessage`Service account details updated`, 
 "AC_ServiceAccountEnabled": defineMessage`Service account enabled`, 
 "AC_ServiceAccountDisabled": defineMessage`Service account disabled`, 
 "AC_AccessKeyCreated": defineMessage`Access key created`, 
 "AC_AccessKeyDeleted": defineMessage`Access key deleted`, 
 "AC_AccessKeyDetailsUpdated": defineMessage`Access key details updated`, 
 "AC_PortalUserCreated": defineMessage`Added a portal user`, 
 "AC_PortalUserUpdated": defineMessage`Updated a portal user's details`, 
 "AC_PortalUserProfileUpdated": defineMessage`Updated own profile`, 
 "AC_PortalUserPreferenceUpdated": defineMessage`Applied filter/sort in user management`, 
 "AC_ResentVerificationEmail": defineMessage`Resent verification email`, 
 "AC_PortalUserActivated": defineMessage`Activated a portal user`, 
 "AC_PortalUserDeactivated": defineMessage`Deactivated a portal user`, 
 "AC_ResetPortalUserPassword": defineMessage`Reset portal user password`, 
 "AC_BulkResentVerificationEmail": defineMessage`Resent verification emails in bulk`, 
 "AC_PortalUserDataExported": defineMessage`Exported portal user data`, 
 "AC_PortalUserDataDownloaded": defineMessage`Downloaded portal user data`, 
 "AC_UserSignedIntoIdP": defineMessage`User signed in to IdP`, 
 "AC_UserSignedIntoPortal": defineMessage`User signed in to portal`, 
 "AC_PortalUserAdministration": defineMessage`Portal user administration`, 
 "AC_PortalUserprofileAdministration": defineMessage`Portal user profile administration`, 
 "AC_PortalUserPreference": defineMessage`Portal user preference`, 
 "AC_PortalUserActivity": defineMessage`Portal user activity`, 
 "AC_OAuthGrantCreated": defineMessage`OAuth access granted`, 
 "AC_OAuthTokenGenerated": defineMessage`OAuth access token generated`, 
 "AC_OAuthGrantRevoked": defineMessage`OAuth access revoked`, 
 "AC_OAuthAccess": defineMessage`OAuth access administration`,
};